module.exports = __webpack_public_path__ + "img/Lighting.f8e32403.gif";